import { Paper, Stack, Text } from "@mantine/core";

interface DiscussionReasonCardProps {
  reason: string;
}

export function DiscussionReasonCard({ reason }: DiscussionReasonCardProps) {
  return (
    <Paper withBorder p="md">
      <Stack gap="xs">
        <Text size="xs" c="dimmed" tt="uppercase" fw={500}>
          Discussion reason
        </Text>
        <Text size="sm" style={{ whiteSpace: "pre-wrap" }}>
          {reason}
        </Text>
      </Stack>
    </Paper>
  );
}
